import React, { useEffect, useState } from 'react'
import FaqsTable from './../components/table/Faqs'
import './style.css'
import addBtn from './../images/add-button.png'
import closeBtn from './../images/close-button.png'
import { addFaq, getAllFaqs, editFaq } from '../../../api'
import { Navigate } from 'react-router-dom';
import axios from 'axios'

function Faqs(){
  const [isAuth, setIsAuth] = useState(false)
  const [isLoading, setIsLoading] = useState(true)
  const [edit, setEdit] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  useEffect(() => {
    const isAuthenticated = () => {
      axios.get('https://job-portal-back123.herokuapp.com/auth/admin/verify', {
        credentials: "include",
        withCredentials: true,
        headers: {
          Authorization: localStorage.getItem("token")
        }
      }).then(res => {
        setIsAuth(res.data.success)
        setIsLoading(false)
      }).catch(err => {
        console.log(err)
        window.location = "/admin/signin"
      })
    }
    isAuthenticated()
  }, [])
  const [ formData, setFormData ] = useState({
    ques: "",
    ans: ""
  })

  const [isPoped, setIsPoped] = useState(false)

  const handleChange = (event)=>{
    const { name, value } = event.target
    setFormData(prevFormData => {
        return {
            ...prevFormData,
            [name]: value
        }
    })
  }

  const handleSubmit = async (event)=>{
    event.preventDefault();
    setIsSubmitting(true)

    try {
      const { data } = edit ? await editFaq(formData._id, formData) : await addFaq(formData);
      console.log("Data:", data)
      if (data.success) {
       alert("FAQ added succesfully!") 
       setIsSubmitting(false)
      } else {
        setErrorMessage("Error submitting job")
        setIsSubmitting(false)
        console.log("error")
      }
    } catch (error) {
      setErrorMessage(error.message)
      setIsSubmitting(false)
    }

  }

  const openForm = ({ faqData })=>{
    if (faqData) {
      formData.ques = faqData.ques
      formData.ans = faqData.ans
      formData._id = faqData._id
      setEdit(true)
    } else {
      setEdit(false)
      formData.ques = ""
      formData.ans = ""
    }
    setIsPoped(true)
  }

  const closeForm = ()=>{
    setIsPoped(false)
    setEdit(false)
  }

  return(
    <>
      {isLoading && <div>Loading...</div>}
      {(!isLoading && !isAuth) && <Navigate to="/admin/signin" />}
      {(!isLoading && isAuth) && (
        <main className="admin__component admin__faq">
          <button className="btn btn--circle" onClick={openForm}><img src={addBtn} alt="add Faqs" /></button>
          <form onSubmit={(e) => handleSubmit(e)} className={`admin__form faq__form ${isPoped ? "" : "form__hide"}`}>
            <button className="btn btn--circle form__close" onClick={closeForm}><img src={closeBtn} alt="close add faq form" /></button>
            <label className="faq__form__element">
              <p>Question</p>
              <textarea
                className="faq__form__textarea form__textarea"
                value={formData.ques}
                placeholder="question"
                onChange={handleChange}
                name="ques"
                required
              />

            </label>

            <label className="faq__form__element">
              <p>Answer</p>
              <textarea
                className="faq__form__textarea form__textarea"
                value={formData.ans}
                placeholder="answer"
                onChange={handleChange}
                name="ans"
                required
              />
            </label>
            <div className="btn--container">
              <button disabled={isSubmitting ? true : false} type="submit" className="btn btn--submit">{isSubmitting ? "Saving..." : "Save Faq"}</button>
              <button className="btn btn--delete">Delete</button>
            </div>
            {(errorMessage) && <div className="message__error grid-full">{errorMessage}</div>}
          </form>
          <FaqsTable openForm={openForm} />
        </main>
      )}
    </>
  )
}

export default Faqs
